import { useQuery, UseQueryResult } from 'react-query';
import { KiloClassAthleteAgenda, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseClassAthleteAgendaProps {
  date: string;
  coaches?: string[];
  locations?: string[];
  eventTypes?: string[];
}

function useClassAthleteAgenda({
  date,
  coaches,
  locations,
  eventTypes,
}: IUseClassAthleteAgendaProps): UseQueryResult<{ data: Array<KiloClassAthleteAgenda> }> {
  const params: UrlParams = { date };

  if (coaches && coaches.length > 0) {
    params.coaches = coaches.join(',');
  }

  if (locations && locations.length > 0) {
    params.locations = locations.join(',');
  }

  if (eventTypes && eventTypes.length > 0) {
    params.event_types = eventTypes.join(',');
  }

  return useQuery(['classes', 'athlete-agenda', date, coaches, eventTypes, locations], () =>
    client.get(`kilo-classes/athlete-agenda/?${encodeUrlParams(params)}`),
  );
}

export default useClassAthleteAgenda;
